// ============================================================
// src/pages/about/about.ts
// About Us page controller — handles page initialization and logging.
// ============================================================

export function initAbout(): void {
  console.log("🚀 ~ Initializing About Us Page ~ 🚀");
}